import { autorun, observable } from "mobx";

(function () {
  // escape hatch
  if (!document.querySelector(".rsvp-widget")) return;

  // setup
  const allWidgets = Array.from(document.querySelectorAll(".rsvp-widget"));
  let state = observable({
    userRSVPS: WP.userRSVPS,
    get ui() {
      return allWidgets.map((event) => {
        const eid = parseInt(event.dataset.eid);
        return {
          eid,
          attending: this.userRSVPS.includes(eid),
          eventStatus: event.dataset.eventStatus,
          publishStatus: event.dataset.publishStatus,
        };
      });
    },
  });

  // events
  allWidgets.forEach((widget) => {
    widget.querySelector("button").addEventListener("click", function () {
      lockWidget(widget);
      toggleRSVP(WP.uid, parseInt(widget.dataset.eid));
    });
  });

  // update
  autorun(() => {
    state.ui.forEach((node) => updateWidget(node));
  });

  // functions
  function toggleRSVP(uid, eid) {
    const endpoint = `${window.location.origin}/wp-json/jumbo/v1/rsvp`;
    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": WP.nonce,
      },
      body: JSON.stringify({ eid }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        state.userRSVPS = data;
      })
      .catch((error) => {
        // handle transport error
        console.error("network/transport error rsvping", error);
        // TODO: something like this would be better
        // errorEl.textContent = "Something went wrong, please try again.";
        // successEl.textContent = "";
        // loaderEl.style.display = "none";
      });
  }

  function updateWidget(node) {
    const widget = document.querySelector(
      `.rsvp-widget[data-eid="${node.eid}"]`
    );
    // one-time renders
    if (node.eventStatus === "upcoming") {
      widget.querySelector(".rsvp-button-wrap").style.display = "block";
    }
    if (node.publishStatus === "1") {
      if (
        ["archived", "live"].includes(node.eventStatus) ||
        (node.eventStatus === "upcoming" && node.attending)
      ) {
        widget.querySelector(".event-link-button-wrap").style.display = "block";
      }
    }

    // dynamic render
    if (node.attending) {
      widget.querySelector("button").classList.add("button--bright");
    } else {
      widget.querySelector("button").classList.remove("button--bright");
    }
    widget.querySelector("button strong").textContent = node.attending
      ? "You're going!"
      : "RSVP to event";
    widget.querySelector(".checked").style.display = node.attending
      ? "inline"
      : "none";
    widget.querySelector(".unchecked").style.display = node.attending
      ? "none"
      : "inline";
    unlockWidget(widget);
  }

  function lockWidget(widget) {
    widget.querySelector("button").disabled = true;
    widget.querySelector(".checked").style.display = "none";
    widget.querySelector(".unchecked").style.display = "none";
    widget.querySelector(".loader").style.display = "inline-block";
  }

  function unlockWidget(widget) {
    widget.querySelector("button").disabled = false;
    widget.querySelector(".loader").style.display = "none";
  }
})();
